var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _path3, _path4, _path5, _path6, _rect6, _rect7, _path7, _path8, _rect8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse2Floor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4668 38.8778H58.2111V57.5462H52.7492V43.5245H40.3579V57.5462H5.4668V38.8778Z",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5596,
    height: 4.64672,
    transform: "matrix(1 0 0 -1 1.79785 62.193)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.04887,
    height: 4.64672,
    transform: "matrix(1 0 0 -1 52.749 62.193)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.3916,
    height: 18.6275,
    transform: "matrix(1 0 0 -1 40.3574 62.193)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 59.9997,
    height: 4.64672,
    transform: "matrix(1 0 0 -1 1.79785 38.8778)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0723 62.193H53.0749",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7336,
    height: 8.51898,
    transform: "matrix(1 0 0 -1 12.1201 52.0845)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9873 52.0845V43.5655",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54199 52.0845L30.4318 52.0845",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4668 15.5629H58.2111V34.2313H5.4668V15.5629Z",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7976 15.5629H1.79785L8.31956 5.69878H51.1183H55.2759L61.7976 15.5629Z",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.8423,
    height: 11.0054,
    transform: "matrix(1 0 0 -1 40.2764 11.6497)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7336,
    height: 8.51898,
    transform: "matrix(1 0 0 -1 12.1211 28.7689)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9873 28.7689V20.2499",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54297 28.7689L30.4328 28.7689",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 15.7336,
    height: 8.51898,
    transform: "matrix(1 0 0 -1 35.7412 28.7689)",
    fill: "white",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6074 28.7689V20.2499",
    stroke: "#808080",
    strokeWidth: 1.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1631 28.7689L54.0529 28.7689",
    stroke: "#808080",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse2Floor);
export default __webpack_public_path__ + "static/media/house_2floor.f78e015bf623e7e629fced52f4be561c.svg";
export { ForwardRef as ReactComponent };